<div
  [ngClass]="globalStore.modalSyncState() === 'loading' ? 'modal fade disable-modal-close' : 'modal fade'"
  id="sync-status-modal"
  tabindex="-1"
  aria-labelledby="syncModalLabel"
  aria-hidden="true"
  [attr.data-bs-keyboard]="globalStore.modalSyncState() === 'loading'"
>
  <!-- HEYHEY: The above data-bs-keyboard is so that anytime the modal is loading, we don't let users press the ESC key to get out of the modal. (6/3/2025) There already seems to be protections to prevent clicking on the backdrop to get out of the modal (I think it's the disable-modal-close class but just a theory) BUT if that functionality changes, you can add this to prevent users from clicking on the backdrop during loading: [attr.data-bs-backdrop]="globalStore.modalSyncState() === 'loading' ? 'static' : 'true'" -->

  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <ng-container [ngSwitch]="globalStore.modalSyncState()">
              <ng-container *ngSwitchCase="'loading'">
                  <div class="modal-spinner-container">
                    <c11n-spinner size="medium" colorMode="on-light" spinnerStatus="Loading..."></c11n-spinner>
                  </div>
                  <div class="modal-body modal-spinner-message c11n-text-sm">
                    <p>{{globalStore.modalSyncMessage()}}</p>
                  </div>
              </ng-container>

              <!--TODO: With our globalStore implementation, can remove ngSwitch functionality and just have it be an if/else since the general content can be modified and passed in through the store patch methods-->
              <ng-container *ngSwitchCase="'success'">
                  <div class="modal-header">

                      <h3 class="modal-title c11n-text-lg-bold" id="vanilla-sync-success-modal-label">
                          {{constants.VANILLA_MODAL_SUCCESS_HEADER}}</h3>

                      <div class="modal-close-button">
                          <c11n-icon-button iconName="remove" variant="ghost" size="small" data-bs-dismiss="modal"
                              aria-label="Close">
                          </c11n-icon-button>
                      </div>
                  </div>

                  <div class="modal-body c11n-text-md">
                      <p>{{globalStore.modalSyncMessage()}}</p>
                  </div>
              </ng-container>

              <ng-container *ngSwitchCase="'error'">
                  <div class="modal-header">
                      <h3 class="modal-title c11n-text-lg-bold" id="vanilla-sync-error-modal-label">
                          {{constants.VANILLA_MODAL_ERROR_HEADER}}</h3>

                      <div class="modal-close-button">
                          <c11n-icon-button iconName="remove" variant="ghost" size="small" data-bs-dismiss="modal"
                              aria-label="Close">
                          </c11n-icon-button>
                      </div>
                  </div>

                  <div class="modal-body c11n-text-md">
                      <p>{{globalStore.modalSyncMessage()}}</p>
                  </div>
              </ng-container>

          </ng-container>
      </div>
  </div>
</div>
